// routes
import React from 'react';
import { PATH_DASHBOARD } from '../../../routes/paths';
import SvgIconStyle from '../../../components/SvgIconStyle';

const getIcon = (name) => <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />;
const storedLabels = JSON.parse(localStorage.getItem('labels')) || {};
const leadLabel = storedLabels.leads || 'Lead';
const vendorLabel = storedLabels.vendors || 'Vendors';

const ICONS = {
  dashboard: getIcon('ic_home_dashboard'),
  analytics: getIcon('ic_analytics'),
  inventory: getIcon('ic_inventory'),
  vendors: getIcon('ic_vendors'),
  customers: getIcon('ic_customers'),
  leads: getIcon('ic_leads'),
  order: getIcon('ic_order'),
  employees: getIcon('ic_employees'),
  invoice: getIcon('ic_invoice'),
  setting: getIcon('ic_setting'),
  regionMaster: getIcon('region_master'),
  packageManagement: getIcon('package_management'),
  UnitMaster: getIcon('unit_master'),
  routeIcon: getIcon('ic_route'),
  discountIcon: getIcon('ic_discount'),
  customerIcon: getIcon('ic_customer'),
  farmerIcon: getIcon('ic_farmer'),
  dealerIcon: getIcon('ic_dealer'),
  campaign: getIcon('campaign_icon'),
};

const prepareSidebarValueWithPath = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    items: [
      // { title: 'Dashboard', path: PATH_DASHBOARD.general.app, icon: ICONS.dashboard, modulePath: 'dashboard' },
      { title: 'Analytics', path: PATH_DASHBOARD.general.analytics, icon: ICONS.analytics, modulePath: 'analytics' },
      { title: 'Lead', path: PATH_DASHBOARD.lead.root, icon: ICONS.leads, modulePath: 'leads' },
      { title: 'Order', path: PATH_DASHBOARD.order.root, icon: ICONS.order, modulePath: 'orders' },
      { title: 'Invoice', path: PATH_DASHBOARD.invoice.root, icon: ICONS.invoice, modulePath: 'invoice' },
      { title: 'Vendors', path: PATH_DASHBOARD.general.vendor, icon: ICONS.vendors, modulePath: 'vendor' },
      {
        title: 'Inventory',
        path: PATH_DASHBOARD.inventory.root,
        icon: ICONS.inventory,
        children: [
          { title: 'Category', path: PATH_DASHBOARD.inventory.category },
          { title: 'Product', path: PATH_DASHBOARD.inventory.products },
          { title: 'Stock Management', path: PATH_DASHBOARD.inventory.stock },
          { title: 'Price List', path: PATH_DASHBOARD.inventory.price },
        ],
        modulePath: 'inventory',
      },
      { title: 'Discount', path: PATH_DASHBOARD.discount.root, icon: ICONS.discountIcon, modulePath: 'discount' },
      {
        title: 'Employees',
        path: PATH_DASHBOARD.employee.root,
        icon: ICONS.employees,
        children: [
          { title: 'Employees list', path: PATH_DASHBOARD.employee.employeelist },
          // { title: 'Registered', path: PATH_DASHBOARD.employee.registered },
          // { title: 'Rejected', path: PATH_DASHBOARD.employee.rejected },
          { title: 'Employees target', path: PATH_DASHBOARD.employee.employeetarget },
          { title: 'Attendance report', path: PATH_DASHBOARD.employee.attendance },
        ],
        modulePath: 'employee',
      },
      {
        title: 'Designations',
        path: PATH_DASHBOARD.designation.root,
        icon: ICONS.customers,
        children: [
          { title: 'Designation List', path: PATH_DASHBOARD.designation.designationlist },
          { title: 'Hierarchy', path: PATH_DASHBOARD.designation.hierarchy },
          { title: 'Designation Relation', path: PATH_DASHBOARD.designation.designation_relation },
        ],
        modulePath: 'designation',
      },
      { title: 'Route', path: PATH_DASHBOARD.route.root, icon: ICONS.routeIcon, modulePath: 'route' },
      {
        title: 'Package',
        path: PATH_DASHBOARD.packageManagement.root,
        icon: ICONS.packageManagement,
        modulePath: 'packageList',
      },
      {
        title: 'Unit',
        path: PATH_DASHBOARD.unitMaster.root,
        icon: ICONS.UnitMaster,
        children: [
          { title: 'Unit Master', path: PATH_DASHBOARD.unitMaster.unitMaster },
          { title: 'Hierarchy', path: PATH_DASHBOARD.unitMaster.hierarchy },
        ],
        modulePath: 'unit',
      },
      {
        title: 'Region Master',
        path: PATH_DASHBOARD.regionMaster.root,
        icon: ICONS.regionMaster,
        modulePath: 'regionList',
      },
      {
        title: 'Campaign',
        path: PATH_DASHBOARD.campaign.root,
        icon: ICONS.campaign,
        modulePath: 'campaign',
        children: [
          { title: 'Campaign Analytics', path: PATH_DASHBOARD.campaign.analytics },
          { title: 'Campaign List', path: PATH_DASHBOARD.campaign.list },
          { title: 'QR Code Management', path: PATH_DASHBOARD.campaign.qr },
          { title: 'Farmer Claims', path: PATH_DASHBOARD.campaign.claimed },
        ],
      },
      { title: 'Profile', path: PATH_DASHBOARD.profile.root, icon: ICONS.vendors, modulePath: 'profile' },
      {
        title: 'settings',
        path: PATH_DASHBOARD.settings.root,
        icon: ICONS.setting,
        children: [
          { title: 'Feature Approval', path: PATH_DASHBOARD.settings.featureApproval },
          { title: 'Invoice number pattern', path: PATH_DASHBOARD.settings.invoiceNumberPattern },
          { title: 'Notification', path: PATH_DASHBOARD.settings.notification },
          { title: 'Negative Stock', path: PATH_DASHBOARD.settings.negativeStock },
          { title: 'Random Image', path: PATH_DASHBOARD.settings.randomImage },
          { title: 'Labeling', path: PATH_DASHBOARD.settings.labeling },
          { title: 'Campaign Controls', path: PATH_DASHBOARD.settings.scanAttemptLimit },
        ],
        modulePath: 'settings',
      },
    ],
  },
];

const navConfig = prepareSidebarValueWithPath;
export default navConfig;
